import { Stagger, Item } from "./shared";
import { useI18n } from "../i18n/LanguageContext";

export const Stats = () => {
  const { c } = useI18n();
  return (
    <section className="py-6" data-testid="stats-section">
      <div className="container-x">
        <div className="overflow-hidden rounded-[2rem] bg-gradient-to-br from-gold to-gold-400 px-6 py-12 sm:px-12">
          <Stagger className="grid grid-cols-2 gap-8 lg:grid-cols-4">
            {c.STATS.map((s, i) => (
              <Item key={i} className="text-center">
                <p className="font-display text-4xl font-semibold text-white sm:text-5xl" data-testid={`stat-${i}`}>{s.value}</p>
                <p className="mt-2 text-sm font-medium text-white/85">{s.label}</p>
              </Item>
            ))}
          </Stagger>
        </div>
      </div>
    </section>
  );
};
